import axios from '../jslib/http'
import {request} from '../jslib/request'
const BASE_REQUEST = '/oa/ship'

export function getShipByUni(data) {
    return request({
        url: '/tms/ship/uni',
        method: 'get',
        data
    })
}

export function getShipInfoById(
    id
  ) {
    return request({
        url:`${BASE_REQUEST}/getShipInfoById`,
        data:{id: id}
    })
  }

export function getShipFromShipBase(
  id
) {
  return request({
    url:`${BASE_REQUEST}/getShipFromShipBase`,
    data:{id: id}
  })
}

export function getShipList (pageNo,pageSize) {
    const url = `${BASE_REQUEST}/getShipList`
    var data = {
        pageNo:pageNo,
        pageSize:pageSize,
    }
    return axios
        .get(url, {
            params: data
        })
        .then(res => {
            if (res !== undefined) {
                return Promise.resolve(res.data)
            } else {
                return Promise.resolve(res)
            }
        })
}

export function getMapShips (latitude1,longitude1,latitude2,longitude2) {
    const url = `${BASE_REQUEST}/getMapShips`
    var data = {
        latitude1:latitude1,
        longitude1:longitude1,
        latitude2:latitude2,
        longitude2:longitude2
    }
    return axios
        .get(url, {
            params: data
        })
        .then(res => {
            if (res !== undefined) {
                return Promise.resolve(res.data)
            } else {
                return Promise.resolve(res)
            }
        })
}


export function getMapShipInfo (mmsi) {
    const url = `${BASE_REQUEST}/getMapShipInfo`
    var data = {
        mmsi:mmsi
    }
    return axios
        .get(url, {
            params: data
        })
        .then(res => {
            if (res !== undefined) {
                return Promise.resolve(res.data)
            } else {
                return Promise.resolve(res)
            }
        })
        .finally(

        )
}
